
import React from "react";
import style from "./ETFs.css";
import { getLan } from "../../stores/utils/utilities";
import LogoETFs from "../../assets/images/BIVAETF.png";
import MarketOverviewWidget from "../../components/ui/tradingviewWidget/MarketOverviewWidget";
import TickerTapeWidget from "../../components/ui/tradingviewWidget/TickerTapeWidget";
import VideoPlayerPaged from "../../components/videos/VideoPlayerPaged";
import MarketDataWidget from "../../components/ui/tradingviewWidget/MarketDataWidget";
import CardETFs from "../../components/ui/card/CardETFs";


function ETFs() {
  const marketOverviewSymbols = [{"s":"BIVA:VMEX/19"},{"s":"BIVA:PSOTRAC/15"},{"s":"BIVA:DLRTRAC/15"},{"s":"BIVA:VOO"},
    {"s":"BIVA:SPY"}];
  const marketDataSymbolsGroups = [{"name":"ETFs",
    "symbols":[{"name":"BIVA:VMEX/19", "displayName": "VANGUARD FTSE BIVA MEXICO EQUITY ETF"},
      {"name":"BIVA:PSOTRAC/15", "displayName": "ÍNDICE BMV USD-MXP"},
      {"name":"BIVA:DLRTRAC/15", "displayName": "ÍNDICE BMV MXP-USD"},
      {"name":"BIVA:ESGMEX/ISHRS", "displayName": "ESGMEX-TRAC"},
      {"name":"BIVA:GENIUS/21", "displayName": "Genius"},
      {"name":"BIVA:VOO", "displayName": "VANGUARD S&P 500 ETF"},
      {"name":"BIVA:SPY", "displayName": "SPDR S&P 500 ETF TRUST"},
      {"name":"BIVA:IVV", "displayName": "ISHARES CORE S&P 500 ETF"},
      {"name":"BIVA:VTI", "displayName": "VANGUARD TOTAL STOCK MARKET ETF"},
      {"name":"BIVA:QQQ", "displayName": "INVESCO QQQ TRUST"}]
  }];
  const tickerTapeSymbols = [{"proName":"BIVA:VMEX/19"},{"proName":"BIVA:PSOTRAC/15"},{"proName":"BIVA:DLRTRAC/15"},
    {"proName":"BIVA:VOO"},{"proName":"BIVA:SPY"}];
  const videoKeyword = "ETFs";
  const defaultVideoId = "Lij7oUkiZuY";

  let etfs = [{"title":"Conoce VMEX",
    "body":"Un instrumento de inversión que replica el índice FTSE BIVA, un índice clave en el mercado mexicano. Ya que sigue de cerca el desempeño de las 44 principales empresas que cotizan en el mercado de valores.",
    "src":"/docs/etfs/ETF_VMEX.pdf"},
    {"title":"Próximamente","body":"..."},
    {"title":"Próximamente","body":"..."},
    {"title":"Próximamente","body":"..."}];

  return (
    <div className="container-fluid row">
      <div className="col-12 margen_top_30">
        <img src={LogoETFs} alt="etfs" className={style.logoETFs} />
      </div>
      <div className={["col-12", style.fondo, style.topAndBottomDivider, style.tickerTape].join(" ")}>
        <TickerTapeWidget locale={getLan()} displayMode="compact" symbols={tickerTapeSymbols} />
      </div>
      <div className="row col-12 margen_top_20">
        <div className={[style.fondo, style.rightDivider, "col-lg-8 col-md-12 col-sm-12 col-xs-12"].join(" ")}>
          <h1 className={style.title}>Videos Relevantes</h1>
          <VideoPlayerPaged videoKeyword={videoKeyword} defaultVideoId={defaultVideoId} videosPerPage={3}/>
        </div>
        <div className={[style.fondo, "col-lg-4 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
          <h1 className={style.title}>ETFs Populares</h1>
          <MarketOverviewWidget title="ETFs" widgetStyle={style.marketOverviewWidget}  symbols={marketOverviewSymbols} locale={getLan()} hideTVFooter={true}/>
        </div>
      </div>

      <div className={[style.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

      <div className="row col-12">
        <div className={[style.fondo, "col-12 "].join(" ")}>
          <h1 className={style.title}>Datos de Mercado</h1>
          <MarketDataWidget widgetStyle={style.marketDataWidget} symbolsGroups={marketDataSymbolsGroups} locale={getLan()}/>
        </div>
      </div>

      <div className={[style.bottomDivider, "row col-12 margen_top_10 margen_abajo"].join(" ")}></div>

      <div className="row col-12">
        <div className={[style.fondo, "col-12 row"].join(" ")}>
          <h1 className={[style.title, "col-12 row"].join(" ")}>Sección educativa</h1>
          <div className={[style.cards, "row"].join(" ")} >
            {etfs.map((etf, index) => (
              <div key={"ETFEduca_" + index} className={[style.fondo, "margin_bottom_10 col-lg-3 col-md-12 col-sm-12 col-xs-12"].join(" ")} >
                <CardETFs title={etf.title} body={etf.body} src={etf.src} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="col-12 padding_bottom_100">
        {
          //Footer
        }
      </div>
    </div>
  );
}

export default ETFs;
